import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./assets/animated.css";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.js";
import "./assets/style.scss";
import App from "./components/app";
import * as serviceWorker from "./serviceWorker";

import reportWebVitals from "./reportWebVitals";

import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./themes/theme";
import { Provider } from "react-redux";
import { setupStore } from "./store";
import { CssBaseline } from "@mui/material";

import { MoralisProvider } from "react-moralis";

const store = setupStore();

ReactDOM.render(
  <React.StrictMode>
    <MoralisProvider
      serverUrl="https://v7f3czkmtmmf.usemoralis.com:2053/server"
      appId="8QhdEDdOy6fgMp0Bu6bUXmCU91VSvF1SDJOXbZAQ"
    >
    <BrowserRouter>
    
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </Provider>
    
    </BrowserRouter>
    </MoralisProvider>
  </React.StrictMode>,

  // <BrowserRouter>
  //   <MoralisProvider
  //     serverUrl="https://v7f3czkmtmmf.usemoralis.com:2053/server"
  //     appId="8QhdEDdOy6fgMp0Bu6bUXmCU91VSvF1SDJOXbZAQ"
  //   >
  //     <Provider store={store}>
  //       <ThemeProvider theme={theme}>
  //         <CssBaseline />
  //         <App />
  //       </ThemeProvider>
  //     </Provider>
  //   </MoralisProvider>
  // </BrowserRouter>,

  document.getElementById("root2")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
